import {SMART_SEARCH_KEY} from '../constants/smartSearchKey';

/**
 * Extracts the smart-search string from a (possibly query-modified) filter object.
 *
 * The smart-search value is nested one level deep:
 * `filters[SMART_SEARCH_KEY][SMART_SEARCH_KEY]`. Returns null when absent or when
 * the nested value is not a string.
 */
export const extractSmartSearch = (modifiedFilters: unknown): string | null => {
  const rawSmartFilter = (modifiedFilters as Record<string, unknown> | null | undefined)?.[
    SMART_SEARCH_KEY
  ];
  const nested = (rawSmartFilter as Record<string, unknown> | null | undefined)?.[SMART_SEARCH_KEY];
  return rawSmartFilter != null && typeof nested === 'string' ? nested : null;
};
